import React, { useEffect, useMemo, useState, useRef } from "react";
import FormInput from "../../../modules/ui/Form/FormInput";
import FormData from "../../../modules/ui/Form/FormData";
import FormTime from "../../../modules/ui/Form/FormTime";
import FormCheckbox from "../../../modules/ui/Form/FormCheckbox";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import {
  CLEAR_PAYMENT_INFO,
  COMMON_ERROR,
  COMMON_PAYMENT_COMPLETE,
  COMMON_TOGGLE_LOADING,
  UPDATE_PAYMENT_INTENT_GROUP_ORDER,
} from "../../../store/Common/Common.constant";
import { format } from "date-fns";
import { FORM_CREATE_GO_SET_VAL } from "../../../store/Form/Form.constant";
import { history } from "../../../shared/utils/helpers";
import AnimatedLoader from "../../../modules/ui/animatedLoader";
import getTimestampFromDateAndTime from "../../../hooks/getTimestampFromDateAndTime";
import InputLikeDropdown from "./dropdown";
import { assignGroupOfGroupOrderApi, getGroupsOfGroupOrderApi } from "../../../shared/services/Api/Report";
import {
  Users,
  DollarSign,
  FileText,
  CalendarClock,
  SlidersHorizontal,
  ArrowRight,
} from "lucide-react";

const Team = ({
  address,
  setAddress,
  groupOrders,
  setModalCancel,
  edit,
  uuid,
  minDate,
  error,
  pathname,
  loading,
  setIsCutlerySelected,
  onCickCutlory,
  isCutlery,
  checked,
  onChange,
}) => {
  const deadlineTimeRef = useRef(null);
  const [submitOrdersTime, setSubmitOrdersTime] = useState();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [priceMinSuccess, setPriceMinSuccess] = useState();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupData, setGroupsData] = useState([]);
  const [headcountError, setHeadcountError] = useState(false);
  const [deadlineError, setDeadlineError] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  const deadlineTimeValue = useRef(null);
  const deadlineDateValue = useRef(null);
  const defaultDeadlineTime = "5:00 PM";
  const defaultDeliveryTime = "11:30 AM";
  const timeValue = useRef(null);
  const dateValue = useRef(null);
  const isUpdateable =
    edit &&
    (groupOrders?.name !== values?.name ||
      groupOrders?.head_count !== values?.head_count ||
      groupOrders?.per_person_budget?.cents / 100 !==
      values?.per_person_budget ||
      new Date(deadlineDateValue.current).valueOf() !==
      new Date(values?.deadlineDate).valueOf() ||
      new Date(dateValue.current).valueOf() !==
      new Date(values?.date).valueOf() ||
      timeValue.current !== values?.time ||
      deadlineTimeValue.current !== values?.deadlineTime);
  const dispatch = useDispatch();
  const time = values.time?.split(/[\s:]+/);
  const deadlineTime = values.deadlineTime?.split(/[\s:]+/);
  const gapDaysInHours = values?.allow_last_minute_orders ? 2 :
    (groupOrders?.default_gap_days && groupOrders?.default_gap_days > 0
      ? groupOrders?.default_gap_days
      : 0) * 24;
  // const pre_order_notice_hour = gapDaysInHours && gapDaysInHours > groupOrders?.preset?.pre_order_notice_hour ? gapDaysInHours : groupOrders?.preset?.pre_order_notice_hour;
  const pre_order_notice_hour = values?.allow_last_minute_orders ? 2 :
    groupOrders?.preset?.pre_order_notice_hour + gapDaysInHours;
  const cutloryNeeded = groupOrders?.cutlery_needed;
  const minCents = groupOrders?.preset?.minimum_order_amount_cents;
  const minDateDeadline = Math.max(
    new Date().valueOf() + 7200000,
    new Date().setHours(0, 0, 0, 0)
  );
  const dateToCompare = values?.date;
  const maxDateDeadline =
    dateToCompare instanceof Date
      ? dateToCompare?.getTime() -
      pre_order_notice_hour * 3600000
      : 0;

  const changeVal = () => {
    if (!values.date && minDate) {
      setFieldValue("date", new Date(minDate));
    }
    if (values && address) {
      address.delivery_address &&
        setFieldValue("delivery_address", address.delivery_address);
      address.company_name &&
        setFieldValue("company_name", address.company_name);
      address.date && setFieldValue("date", address.date);
      address.time && setFieldValue("time", address.time);
      address.delivery_latitude &&
        setFieldValue("delivery_latitude", address.delivery_latitude);
      address.delivery_longitude &&
        setFieldValue("delivery_longitude", address.delivery_longitude);
      setAddress("");
    }
    if (values.date && values.date instanceof Date && Array.isArray(time)) {
      const allDate = values.date?.setHours(
        time[2] === "PM" && +time[0] !== 12 ? +time[0] + 12 : +time[0],
        time[1],
        0
      );
      if (allDate && pre_order_notice_hour) {
        const deadLineDateTime = new Date(
          allDate - pre_order_notice_hour * 3600000
        );
        setSubmitOrdersTime(deadLineDateTime);
      }
    }
    setPriceMinSuccess(
      +values.per_person_budget * +values.head_count * 100 >= +minCents
    );
    //  headcount validation
    if (values.head_count && values.head_count < 5) {
      setHeadcountError(true);
    } else {
      setHeadcountError(false);
    }
    error && priceMinSuccess && dispatch({ type: COMMON_ERROR, payload: null });
  };
  useEffect(changeVal, [
    pre_order_notice_hour,
    values.date,
    values.head_count,
    values.per_person_budget,
    minDate,
    address,
  ]);
  useEffect(() => {
    if (groupOrders?.group_order_group) {
      setSelectedGroup(groupOrders?.group_order_group)
    }
  }, [groupOrders]);
  useEffect(() => {
    if (
      values.date instanceof Date &&
      values.time &&
      values.deadlineDate instanceof Date &&
      values.deadlineTime
    ) {
      const deliveryTimestamp = getTimestampFromDateAndTime(
        values.date,
        values.time
      );
      const deadlineTimestamp = getTimestampFromDateAndTime(
        values.deadlineDate,
        values.deadlineTime
      );
      setDeadlineError(deadlineTimestamp >= deliveryTimestamp);
    } else {
      setDeadlineError(false);
    }
  }, [values.date, values.time, values.deadlineDate, values.deadlineTime]);
  useEffect(() => {
    if (values.date && values.date instanceof Date && Array.isArray(time)) {
      const allDate = values.date?.setHours(
        time[2] === "PM" && +time[0] !== 12 ? +time[0] + 12 : +time[0],
        time[1],
        0
      );
      if (allDate && pre_order_notice_hour) {
        const deadLineDateTime = new Date(
          allDate - pre_order_notice_hour * 3600000
        );
        setFieldValue(
          "deadlineTime",
          format(
            new Date(allDate - pre_order_notice_hour * 3600000),
            "h:mm aaa"
          ).toUpperCase()
        );
        setFieldValue("deadlineDate", deadLineDateTime);
      }
    }
  }, [pre_order_notice_hour, values?.date, values?.time]);

  const maximumDeadlineTime = useMemo(() => {
    if (values.date && values.date instanceof Date && Array.isArray(time)) {
      const allDate = new Date(values.date)?.setHours(
        time[2] === "PM" && +time[0] !== 12 ? +time[0] + 12 : +time[0],
        time[1],
        0
      );

      if (allDate && pre_order_notice_hour) {
        const deadLineDateTime = new Date(
          allDate - pre_order_notice_hour * 3600000
        );
        return format(deadLineDateTime, "h:mm aaa").toUpperCase();
      }
    }
    return "5:30 AM";
  }, [pre_order_notice_hour, values?.date, values?.time]);

  useEffect(() => {
    if (
      values.deadlineDate &&
      values.deadlineDate instanceof Date &&
      Array.isArray(deadlineTime)
    ) {
      const allDate = values.deadlineDate.setHours(
        deadlineTime[2] === "PM" && +deadlineTime[0] !== 12
          ? +deadlineTime[0] + 12
          : +deadlineTime[0],
        deadlineTime[1],
        0
      );
      if (allDate) {
        const deadLineDateTime = new Date(allDate);
        setSubmitOrdersTime(deadLineDateTime);
      }
    }
  }, [values?.deadlineDate, values?.deadLineDateTime, values?.deadlineTime]);

  const onLoadInfo = () => {
    groupOrders?.name &&
      !values?.name?.length &&
      setFieldValue("name", groupOrders.name);
    groupOrders?.head_count &&
      !values?.head_count &&
      setFieldValue("head_count", groupOrders.head_count);
    groupOrders?.per_person_budget &&
      !values?.per_person_budget &&
      setFieldValue(
        "per_person_budget",
        groupOrders?.per_person_budget?.cents / 100
      );
    if (
      groupOrders?.delivery_date_time &&
      groupOrders?.delivery_date_time > 0
    ) {
      setFieldValue(
        "time",
        format(
          new Date(groupOrders?.delivery_date_time * 1000),
          "h:mm aaa"
        ).toUpperCase()
      );
      timeValue.current = format(
        new Date(groupOrders?.delivery_date_time * 1000),
        "h:mm aaa"
      ).toUpperCase();
      setFieldValue("date", new Date(groupOrders?.delivery_date_time * 1000));
      dateValue.current = new Date(groupOrders?.delivery_date_time * 1000);
    } else {
      setFieldValue("time", defaultDeliveryTime);
      timeValue.current = defaultDeliveryTime;
      setFieldValue("date", new Date());
      dateValue.current = new Date();
    }
    clearTimeout(deadlineTimeRef.current);
    deadlineTimeRef.current = setTimeout(() => {
      if (groupOrders?.order_deadline && groupOrders?.order_deadline > 0) {
        setFieldValue(
          "deadlineTime",
          format(
            new Date(groupOrders?.order_deadline * 1000),
            "h:mm aaa"
          ).toUpperCase()
        );
        setFieldValue(
          "deadlineDate",
          new Date(groupOrders?.order_deadline * 1000)
        );
        deadlineDateValue.current = new Date(
          groupOrders?.order_deadline * 1000
        );
        deadlineTimeValue.current = format(
          new Date(groupOrders?.order_deadline * 1000),
          "h:mm aaa"
        ).toUpperCase();
      } else {
        const [deliveryHour, deliveryMinute, deliveryPeriod] =
          defaultDeliveryTime.split(/[\s:]+/);
        const deliveryHour24 =
          deliveryPeriod === "PM" && +deliveryHour !== 12
            ? +deliveryHour + 12
            : deliveryPeriod === "AM" && +deliveryHour === 12
              ? 0
              : +deliveryHour;
        const defaultDeliveryDateTime = new Date();
        defaultDeliveryDateTime.setHours(deliveryHour24, +deliveryMinute, 0, 0);
        const defaultDeadlineDateTime = new Date(
          defaultDeliveryDateTime.getTime() -
          (pre_order_notice_hour || 0) * 3600000
        );
        const defaultDeadlineTimeLabel = format(
          defaultDeadlineDateTime,
          "h:mm aaa"
        ).toUpperCase();
        setFieldValue("deadlineTime", defaultDeadlineTimeLabel);
        setFieldValue("deadlineDate", defaultDeadlineDateTime);
        deadlineDateValue.current = defaultDeadlineDateTime;
        deadlineTimeValue.current = defaultDeadlineTimeLabel;
      }
    });
    groupOrders?.name && setFieldValue("confirm", ["yas"]);
    groupOrders?.name && setFieldValue("cutlery_needed", false);
  };

  useEffect(onLoadInfo, [groupOrders]);
  const onClickContinue = () => {
    if (
      priceMinSuccess &&
      values.per_person_budget &&
      values.head_count &&
      values.name &&
      values.confirm?.[0] === "yas" &&
      !deadlineError
    ) {
      dispatch({ type: COMMON_ERROR, payload: null });
      dispatch({
        type: FORM_CREATE_GO_SET_VAL,
        payload: { values: values, uuid: uuid },
      });
      if (edit) {
        groupOrders?.head_count !== values?.head_count ||
          groupOrders?.per_person_budget.cents / 100 !==
          values?.per_person_budget ||
          groupOrders?.payment_status === "setup_intent_created"
          ? dispatch({ type: CLEAR_PAYMENT_INFO, payload: uuid })
          : dispatch({ type: COMMON_PAYMENT_COMPLETE, payload: uuid });
      }
      if (isUpdateable) {
        let {
          date,
          time,
          confirm,
          isStorey,
          storey,
          deadlineDate,
          deadlineTime,
          ...val
        } = values;
        dispatch({ type: FORM_CREATE_GO_SET_VAL, payload: { values, uuid } });
        val.delivery_date_time = date.setHours(
          time.split(/[\s:]+/)[2] === "PM" && +time.split(/[\s:]+/)[0] !== 12
            ? +time.split(/[\s:]+/)[0] + 12
            : +time.split(/[\s:]+/)[0],
          time.split(/[\s:]+/)[1],
          0
        );
        val.order_deadline = deadlineDate.setHours(
          deadlineTime.split(/[\s:]+/)[2] === "PM" &&
            +deadlineTime.split(/[\s:]+/)[0] !== 12
            ? +deadlineTime.split(/[\s:]+/)[0] + 12
            : +deadlineTime.split(/[\s:]+/)[0],
          deadlineTime.split(/[\s:]+/)[1],
          0
        );
        dispatch({
          type: UPDATE_PAYMENT_INTENT_GROUP_ORDER,
          payload: {
            group_order: {
              ...val,
              additional_delivery_options: isStorey ? storey : [],
            },
            id: groupOrders?.id,
            uuid,
            redirect: pathname + "#delivery",
          },
        });
      } else {
        dispatch({ type: COMMON_TOGGLE_LOADING, payload: true });
        setTimeout(() => {
          dispatch({ type: COMMON_TOGGLE_LOADING, payload: false });
          history.push(pathname + "#delivery");
        }, 400);
      }
    } else {
      setSubmitSuccess(true);
      //  setIsCutlerySelected(true);
      !priceMinSuccess &&
        dispatch({
          type: COMMON_ERROR,
          payload:
            "The minimum order amount for this vendor has not been met, please increase your headcount or budget to meet the minimum of " +
            groupOrders?.tax_info?.currency +
            minCents / 100 +
            ".",
        });
    }
  };
  const fetchGroups = async () => {
    try {
      const response = await getGroupsOfGroupOrderApi({ user_id: groupOrders?.creator_id });
      if (response) {
        setGroupsData(response);
      }
    } catch (error) {
      console.error("Failed to fetch groups", error);
    }
  };
  useEffect(() => {
    if (groupOrders?.creator_id) {
      fetchGroups();
    }
  }, [groupOrders?.creator_id]);

  const onHandleSelect = async (group) => {
    const response = await assignGroupOfGroupOrderApi({ group_order_id: groupOrders?.id, group_id: group?.id });
    if (response) {
      setSelectedGroup(group);
    }
  };
  return (
    <>
      <AnimatedLoader isLoading={loading} />
      <div className="head__form">
        <h2>Start a Corporate Order</h2>
        <p>Plan a one-day meal for your office and let your team pick their own orders.</p>
      </div>
      <div className="form__section">
      <div className="form__section-header">
        <span className="form__section-icon">
          <Users size={20} />
        </span>
        <div>
          <h3>Order Information</h3>
          <p>Tell us about your corporate order</p>
        </div>
      </div>
      <div className="double__field one__length">
        <div className="form__group tooltip__group">
          <p>
            Order Name*
            <span>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.88935 1.61083C7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083C-0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935C4.25872 11.5368 7.74122 11.537 9.88935 9.38935C12.037 7.24122 12.0368 3.75896 9.88935 1.61083ZM6.71725 7.89142C6.71725 8.28766 6.39609 8.60882 5.99985 8.60882C5.60361 8.60882 5.28245 8.28766 5.28245 7.89142V5.02182C5.28245 4.62558 5.60361 4.30442 5.99985 4.30442C6.39609 4.30442 6.71725 4.62558 6.71725 5.02182V7.89142ZM5.30708 3.14152C5.29847 3.50285 5.57395 3.79555 5.98718 3.79555C6.41762 3.79555 6.69286 3.50285 6.6931 3.14152C6.68425 2.76297 6.41738 2.47888 5.99555 2.47888C5.57395 2.47888 5.29847 2.76273 5.30708 3.14152Z"
                  fill="#9C9C9C"
                />
              </svg>
            </span>
          </p>
          <div className="tooltip__info">
            <p>
              This name shows up on the invite every team member receives, so
              make it easy to recognize — something like "Friday Office Lunch"
              or "Q3 Planning Meeting" works great.
            </p>
          </div>
          <div className="icon__field">
            <FileText className="field__icon" size={16} />
            <FormInput
              error={!values.name && submitSuccess}
              required={true}
              placeholder="Friday Office Lunch, Q3 Planning Meeting…"
              classContainer="form__field"
              type="text"
              name="name"
            />
          </div>
        </div>
      </div>
      <div className="double__field">
        <div className="form__group tooltip__group">
          <p>
            Headcount*
            <span>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.88935 1.61083C7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083C-0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935C4.25872 11.5368 7.74122 11.537 9.88935 9.38935C12.037 7.24122 12.0368 3.75896 9.88935 1.61083ZM6.71725 7.89142C6.71725 8.28766 6.39609 8.60882 5.99985 8.60882C5.60361 8.60882 5.28245 8.28766 5.28245 7.89142V5.02182C5.28245 4.62558 5.60361 4.30442 5.99985 4.30442C6.39609 4.30442 6.71725 4.62558 6.71725 5.02182V7.89142ZM5.30708 3.14152C5.29847 3.50285 5.57395 3.79555 5.98718 3.79555C6.41762 3.79555 6.69286 3.50285 6.6931 3.14152C6.68425 2.76297 6.41738 2.47888 5.99555 2.47888C5.57395 2.47888 5.29847 2.76273 5.30708 3.14152Z"
                  fill="#9C9C9C"
                />
              </svg>
            </span>
          </p>
          <div className="tooltip__info">
            <p>
              Enter roughly how many people you expect to join. It's safer to
              round up — if you're expecting around 20, entering 25-30 covers
              any last-minute additions.
              <br />
              Note: This number is used to calculate your initial charge, but
              you're only ever billed for orders actually placed. If 20 of the
              30 you budgeted for join in, the difference for the other 10 is
              refunded to your card.
            </p>
          </div>
          <div className="icon__field">
            <Users className="field__icon" size={16} />
            <FormInput
              error={(!values.head_count || !priceMinSuccess) && submitSuccess}
              numberZeroValue={false}
              options={{ min: edit ? groupOrders?.head_count : 1 }}
              placeholder="80"
              required={true}
              classContainer="form__field"
              type="number"
              name="head_count"
            />
          </div>
          {headcountError && (
            <div style={{ color: "red" }}>
              <p>The group must be 5 or greater to continue.</p>
            </div>
          )}
        </div>
        <div className="form__group tooltip__group">
          <p>
            Per person budget*
            <span>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.88935 1.61083C7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083C-0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935C4.25872 11.5368 7.74122 11.537 9.88935 9.38935C12.037 7.24122 12.0368 3.75896 9.88935 1.61083ZM6.71725 7.89142C6.71725 8.28766 6.39609 8.60882 5.99985 8.60882C5.60361 8.60882 5.28245 8.28766 5.28245 7.89142V5.02182C5.28245 4.62558 5.60361 4.30442 5.99985 4.30442C6.39609 4.30442 6.71725 4.62558 6.71725 5.02182V7.89142ZM5.30708 3.14152C5.29847 3.50285 5.57395 3.79555 5.98718 3.79555C6.41762 3.79555 6.69286 3.50285 6.6931 3.14152C6.68425 2.76297 6.41738 2.47888 5.99555 2.47888C5.57395 2.47888 5.29847 2.76273 5.30708 3.14152Z"
                  fill="#9C9C9C"
                />
              </svg>
            </span>
          </p>
          <div className="tooltip__info">
            <p>
              This sets the spending cap for each person's order — team members
              won't be able to go over this amount.
            </p>
          </div>
          <div className="icon__field">
            <DollarSign className="field__icon" size={16} />
            <FormInput
              error={
                (!values.per_person_budget || !priceMinSuccess) && submitSuccess
              }
              numberZeroValue={false}
              options={{
                min: edit ? groupOrders?.per_person_budget?.cents / 100 : 1,
              }}
              placeholder="25"
              required={true}
              classContainer="form__field"
              type="number"
              name="per_person_budget"
            />
          </div>
        </div>
      </div>
      </div>
      <div className="form__section">
      <div className="form__section-header">
        <span className="form__section-icon">
          <CalendarClock size={20} />
        </span>
        <div>
          <h3>Schedule &amp; Timing</h3>
          <p>When do you need the order?</p>
        </div>
      </div>
      <div className="time__field">
        <div className="form__group tooltip__group">
          <p>
            Date and time for delivery
            <span>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.88935 1.61083C7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083C-0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935C4.25872 11.5368 7.74122 11.537 9.88935 9.38935C12.037 7.24122 12.0368 3.75896 9.88935 1.61083ZM6.71725 7.89142C6.71725 8.28766 6.39609 8.60882 5.99985 8.60882C5.60361 8.60882 5.28245 8.28766 5.28245 7.89142V5.02182C5.28245 4.62558 5.60361 4.30442 5.99985 4.30442C6.39609 4.30442 6.71725 4.62558 6.71725 5.02182V7.89142ZM5.30708 3.14152C5.29847 3.50285 5.57395 3.79555 5.98718 3.79555C6.41762 3.79555 6.69286 3.50285 6.6931 3.14152C6.68425 2.76297 6.41738 2.47888 5.99555 2.47888C5.57395 2.47888 5.29847 2.76273 5.30708 3.14152Z"
                  fill="#9C9C9C"
                />
              </svg>
            </span>
          </p>
          <div className="tooltip__info">
            <p>
              Vendors need a minimum lead time, so only qualifying dates are
              selectable. Build in some cushion for traffic and other delays —
              picking a slightly earlier time means the food is more likely to
              land on schedule. Need it there by 11:30am? Aim for an 11:15am
              delivery time instead.
            </p>
          </div>
          <div className="date__time--double">
            {minDate && values.date ? (
              <>
                <FormData
                  value={values?.date}
                  setFieldValue={setFieldValue}
                  minDate={minDate}
                  avoidDefault={edit}
                  name="date"
                />
                <FormTime value={values?.date} minDate={null} name="time" />
              </>
            ) : null}
          </div>
          {error && !priceMinSuccess ? (
            <div className="tip__info">
              <p>{error}</p>
            </div>
          ) : null}
        </div>
      </div>
      {/*Set Order Submission Deadline: */}
      <div className="time__field">
        <div className="form__group tooltip__group">
          <p>
            Set Order Submission Deadline:
            <span>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.88935 1.61083C7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083C-0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935C4.25872 11.5368 7.74122 11.537 9.88935 9.38935C12.037 7.24122 12.0368 3.75896 9.88935 1.61083ZM6.71725 7.89142C6.71725 8.28766 6.39609 8.60882 5.99985 8.60882C5.60361 8.60882 5.28245 8.28766 5.28245 7.89142V5.02182C5.28245 4.62558 5.60361 4.30442 5.99985 4.30442C6.39609 4.30442 6.71725 4.62558 6.71725 5.02182V7.89142ZM5.30708 3.14152C5.29847 3.50285 5.57395 3.79555 5.98718 3.79555C6.41762 3.79555 6.69286 3.50285 6.6931 3.14152C6.68425 2.76297 6.41738 2.47888 5.99555 2.47888C5.57395 2.47888 5.29847 2.76273 5.30708 3.14152Z"
                  fill="#9C9C9C"
                />
              </svg>
            </span>
          </p>
          <div className="tooltip__info">
            <p>
              This is the cutoff for when team members can still choose their
              meal. Set it at least 4 hours ahead of delivery so the chef has
              enough time to cook everything fresh. For a 1:30 PM delivery, a
              9:00 AM deadline is a safe bet — anyone who hasn't chosen by then
              won't be included in the order.
            </p>
          </div>
          <div className="date__time--double">
            {minDate && values.deadlineDate ? (
              <>
                <FormData
                  avoidDefault={edit}
                  maxDate={maxDateDeadline}
                  value={values?.deadlineDate}
                  setFieldValue={setFieldValue}
                  disabled={false}
                  minDate={minDateDeadline}
                  name="deadlineDate"
                />
                <FormTime
                  selectedDateValue={values?.deadlineDate}
                  maxDate={maxDateDeadline}
                  maximumDeadlineTime={maximumDeadlineTime}
                  value={values?.deadlineTime}
                  disabled={false}
                  minDate={minDateDeadline}
                  avoidInitial={values?.allow_last_minute_orders}
                  name="deadlineTime"
                />
              </>
            ) : null}
          </div>
          {deadlineError && (
            <div style={{ color: "red" }}>
              <p>Order deadline cannot be later than the delivery date/time.</p>
            </div>
          )}
        </div>
      </div>
      </div>
      {groupData?.length > 0 ?
        <InputLikeDropdown
          options={groupData}
          value={selectedGroup}
          setValue={onHandleSelect}
        />
        : null}
      <div className="form__section">
      <div className="form__section-header">
        <span className="form__section-icon">
          <SlidersHorizontal size={20} />
        </span>
        <div>
          <h3>Additional Options</h3>
          <p>Customize your corporate order</p>
        </div>
      </div>
      {values.head_count && values.head_count <= 80 && (
        <div className="form__check mt-3 mb-1">
          <div className="form__group tooltip__group">
            <ul>
              <li>
                <div className="form__checkbox-with-tooltip">
                  <FormCheckbox
                    name="allow_last_minute_orders"
                    id="styled-checkbox-3"
                    title="Allow for last minute orders"
                  />

                  <span className="tooltip__icon">
                    <svg
                      width="12"
                      height="11"
                      viewBox="0 0 12 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M 9.88935 1.61083 C 7.74146 -0.536824 4.25896 -0.537063 2.11083 1.61083 C -0.0370629 3.75872 -0.0368238 7.24122 2.11083 9.38935 C 4.25872 11.5368 7.74122 11.537 9.88935 9.38935 C 12.037 7.24122 12.0368 3.75896 9.88935 1.61083 Z M 6.71725 7.89142 C 6.71725 8.28766 6.39609 8.60882 5.99985 8.60882 C 5.60361 8.60882 5.28245 8.28766 5.28245 7.89142 V 5.02182 C 5.28245 4.62558 5.60361 4.30442 5.99985 4.30442 C 6.39609 4.30442 6.71725 4.62558 6.71725 5.02182 V 7.89142 Z M 5.30708 3.14152 C 5.29847 3.50285 5.57395 3.79555 5.98718 3.79555 C 6.41762 3.79555 6.69286 3.50285 6.6931 3.14152 C 6.68425 2.76297 6.41738 2.47888 5.99555 2.47888 C 5.57395 2.47888 5.29847 2.76273 5.30708 3.14152 Z"
                        fill="#9C9C9C"
                      />
                    </svg>

                    <div className="tooltip__info">
                      <p>
                        Groups of 50 or fewer can turn this on to let stragglers pick their meal the same day — right up until 2 hours before delivery.
                      </p>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
      {/* CHeckbox cutlory  */}
      <div className="form__check">
        <ul>
          <li>
            <FormCheckbox
              name="cutlery_needed"
              id="styled-checkbox-2"
              title={
                groupOrders?.is_complimentary_cutlery == true
                  ? "Cutlery's on us — include it for free"
                  : "Include cutlery for $0.50 per person who joins"
              }
            />
          </li>
        </ul>
      </div>
      <div className="require__form">
        {/* <div className="elem__require">
          <div className="require__image">
            <img src="/img/require1.svg" alt="require" />
          </div>
          <div className="require__info">
            <span>This vendor requires:</span>
            <p>{pre_order_notice_hour} hours notice</p>
          </div>
        </div> */}
        <div className="elem__require">
          <div className="require__image">
            <img src="/img/require2.svg" alt="require" />
          </div>
          <div className="require__info">
            <span>Team members can choose their meal until:</span>
            <p>
              {submitOrdersTime &&
                format(submitOrdersTime, "EEEE MMMM do") ===
                format(new Date(), "EEEE MMMM do")
                ? "(TODAY) "
                : null}
              {submitOrdersTime &&
                format(submitOrdersTime, "EEEE, MMMM do, h:mm aaa")}
            </p>
          </div>
        </div>
        <div className="elem__require">
          <div className="require__image">
            <img src="/img/require3.svg" alt="require" />
          </div>
          <div className="require__info">
            <span>Your order goes to the kitchen on:</span>
            <p>
              {submitOrdersTime &&
                format(submitOrdersTime, "EEEE MMMM do") ===
                format(new Date(), "EEEE MMMM do")
                ? "(TODAY) "
                : null}
              {submitOrdersTime &&
                format(submitOrdersTime, "EEEE, MMMM do, h:mm aaa")}
            </p>
          </div>
        </div>
      </div>
      </div>
      <div className="form__check">
        <ul>
          <li>
            <FormCheckbox
              error={values.confirm?.[0] !== "yas" && submitSuccess}
              name="confirm"
              value="yas"
              title="Got it, I agree to the details above."
            />
          </li>
        </ul>
      </div>
      <div className="form__submit">
        <button type="button" onClick={onClickContinue} disabled={headcountError || deadlineError} >
          {isUpdateable ? "Update" : "Continue"}
          <ArrowRight size={18} />
        </button>
      </div>
      {edit ? (
        <div className="form__back">
          <button type="button" onClick={() => setModalCancel(true)}>
            Cancel this order
          </button>
        </div>
      ) : null}
    </>
  );
};
export default Team;
